<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New Reason</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-row>
              <b-col md="12">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="input-group-1"
                      class="required"
                      label-class="control-label"
                      label="Group Title"
                      label-for="input-1"
                    >
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="group_title"
                        data-vv-as="Group Title"
                        v-model="group_title"
                        placeholder="Group Title"
                      />
                      <b-form-invalid-feedback
                        id="input-group_title-feedback"
                      >{{ veeErrors.first('group_title') }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="form-group" v-for="(input , k) in reason" :key="k">
                  <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="fieldset-1"
                        label-class="mb-0"
                        label-for="input-1"
                      >Reason {{k+1}}</b-form-group>
                    </b-col>
                    <b-col md="3" class="text-right">
                      <b-link
                        style="text-decoration: none;"
                        class="text-danger"
                        @click="remove(k)"
                        v-show="k || ( !k && reason.length > 1)"
                      >Remove</b-link>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="title_id"
                        data-vv-as="Title Bahasa"
                        v-model="input.id"
                        placeholder="Title Bahasa"
                      />
                      <b-form-invalid-feedback
                        id="input-title_id-feedback"
                      >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col>
                      <input
                        id="input-1"
                        type="text"
                        class="form-control"
                        v-validate="'required|max:25'"
                        name="title_en"
                        data-vv-as="Title English"
                        v-model="input.en"
                        placeholder="Title English"
                      />
                      <b-form-invalid-feedback
                        id="input-title_en-feedback"
                      >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3" class="mt-4">
                      <b-button
                        block
                        variant="outline-primary"
                        @click="add(k)"
                        v-show="k == reason.length-1"
                      >
                        <i class="fas fa-plus"></i> Add More
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                <br />
                <b-row class="text-right">
                  <b-col>
                    <b-button
                      variant="primary"
                      @click="post()"
                      :disabled="loading"
                      class="mr-5"
                    >Create</b-button>
                    <router-link :to="{name: 'Reason'}">
                      <b-button variant="outline-secondary">Cancel</b-button>
                    </router-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      loading: false,
      group_title: '',
      reason: [
        {
          id: null,
          en: null,
        },
      ],
    };
  },
  methods: {
    add(index) {
      this.reason.push({
        id: null,
        en: null,
      });
    },
    remove(index) {
      this.reason.splice(index, 1);
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData();
          formData.append('group_title', this.group_title);
          $.each(this.reason, (index, value) => {
            formData.append('sequence', index);
            formData.append(`reason_id[${index}]`, value.id);
            formData.append(`reason_en[${index}]`, value.en);
          });
          this.loading = true;
          this.$store
            .dispatch('RatingModule/postReason', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'Reason' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
  },
};
</script>


<style scoped>
</style>
